import { baseApi } from "../baseApi";
import type {
    DashboardOverviewQuery,
    DashboardOverviewResponse,
} from "../../types/dashboard";

const dashboardTag = "Dashboard";

export const dashboardApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getDashboardOverview: builder.query<
            DashboardOverviewResponse,
            DashboardOverviewQuery
        >({
            query: ({ period, company_id }) => ({
                url: `/dashboard/overview`,
                params: { period, ...(company_id ? { company_id } : {}) },
            }),
            providesTags: [dashboardTag],
        }),
    }),
});

export const {
    useGetDashboardOverviewQuery,
    useLazyGetDashboardOverviewQuery,
} = dashboardApi;
